import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "ec-102323bb-3ba9-4b51-aeee-e4c803d020c0-__Layer",
  height: "512",
  viewBox: "0 0 24 24",
  width: "512",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("rect", {
      width: "24",
      height: "24",
      style: {"fill":"rgb(164, 164, 164)"}
    }, null, -1),
    _createElementVNode("path", {
      id: "ec-eb0011b1-9228-4547-9f29-efcb83ac5ebf-__box",
      d: "M 10.988 11.465 C 11.153 11.533 11.324 11.587 11.5 11.625 L 11.5 17.971 C 11.392 17.944 11.288 17.905 11.186 17.857 L 7.187 16.078 C 6.466 15.756 6 15.041 6 14.251 L 6 9.811 C 6.002 9.634 6.026 9.456 6.074 9.285 L 10.988 11.465 Z M 13.88 9.978 L 8.447 7.425 L 7.187 7.985 C 6.959 8.085 6.754 8.227 6.58 8.405 L 11.387 10.545 C 11.777 10.717 12.224 10.717 12.614 10.545 L 13.88 9.978 Z M 17.42 8.405 C 17.246 8.227 17.042 8.085 16.814 7.985 L 12.814 6.204 C 12.296 5.971 11.704 5.971 11.186 6.204 L 9.66 6.885 L 15.094 9.438 L 17.42 8.405 Z M 17.927 9.285 L 15.587 10.325 L 15.587 11.958 C 15.587 12.343 15.17 12.583 14.837 12.391 C 14.682 12.301 14.587 12.137 14.587 11.958 L 14.587 10.764 L 13.013 11.465 C 12.848 11.531 12.676 11.585 12.5 11.625 L 12.5 17.971 C 12.608 17.944 12.712 17.905 12.814 17.857 L 16.814 16.078 C 17.534 15.756 18 15.041 18 14.251 L 18 9.811 C 17.999 9.634 17.975 9.456 17.927 9.285 Z",
      style: {"fill":"rgb(219, 219, 219)"}
    }, null, -1)
  ]))]))
}
export default { render: render }